var render = function render(){var _vm=this,_c=_vm._self._c;return (Object.keys(_vm.dataReports).length > 0)?_c('ProfitReportTotalAdmin',{attrs:{"dataReports":_vm.dataReports,"dataLeftBlock":_vm.dataLeftBlock},on:{"filter":_vm.filter}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }